<template>
    <div class="container section-menu-page">
        <div class="section-title-wrap">
            <h2 class="section-title">{{ labels.title }}</h2>
        </div>
        <div>
            <div class="admin-home-card table-corporate-body main-menu-scroll-shell">
                <div v-if="isLoading" style="min-height: 300px;"></div>

                <b-container v-else style="padding: 18px 40px 40px; height: 100%;">
                    <div v-if="visibleSubmenus.length > 0" class="menu-grid">
                        <div
                            v-for="subMenu in visibleSubmenus"
                            :key="subMenu.id || subMenu.ruta"
                            class="menu-grid-item"
                        >
                            <div class="menu-item-wrapper">
                                <button
                                    type="button"
                                    class="md-card admin-menu-card-button"
                                    @click="goToRoute(subMenu)"
                                >
                                    <div>
                                        <div>
                                            <div class="md-title-tarjeta">
                                                <span>{{ subMenu?.nombre }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                                <div class="div-description-fixed">
                                    <i class="fas fa-info-circle info-icon"></i>
                                    <span class="description-text">{{ subMenu?.descripcion || subMenu?.nombre }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else class="menu-grid">
                        <div
                            v-for="item in fallbackSubmenus"
                            :key="item.id"
                            class="menu-grid-item"
                        >
                            <div class="menu-item-wrapper">
                                <button
                                    type="button"
                                    class="md-card admin-menu-card-button"
                                    @click="goToRoute(item)"
                                >
                                    <div>
                                        <div>
                                            <div class="md-title-tarjeta">
                                                <span>{{ item.nombre }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                                <div class="div-description-fixed">
                                    <i class="fas fa-info-circle info-icon"></i>
                                    <span class="description-text">{{ item.descripcion || item.nombre }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
import Menu from '../../services/Menu'; 
import SubMenu from '../../services/SubMenu'; 

export default {
    name: "Administrador",
    data: () => ({
        listaSubMenu: [],
        isLoading: true,
        error: false
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Administrador",
                    users: "Usuarios",
                    usersd: "Administración de Usuarios",
                    menu: "Menús",
                    descripMenu: "Administración de Menús",
                    subMenu: "Submenús",
                    descripSubMenu: "Administración de submenus",
                    roles: "Roles",
                    descripRole: "Administración de Roles",
                    cargues: "Cargues",
                    carguesd: "Definición de formatos de cargues",
                    buttonControl: "Panel de Control",
                    buttonControld: "Administración de controles por componente y rol",
                }
            } else {
                return {
                    title: "Administrator",
                    users: "Users",
                    usersd: "Users Administration",
                    menu: "Menus",
                    descripMenu: "Menus Administration",
                    subMenu: "Submenus management",
                    descripSubMenu: "submenus description",
                    roles: "Role",
                    descripRole: "Role Administration",
                    cargues: "Uploads",
                    carguesd: "Upload Format Definition",
                    buttonControl: "Control Panel",
                    buttonControld: "Control management by component and role",
                }
            }
        },
        visibleSubmenus() {
            return this.listaSubMenu.length > 0 ? this.listaSubMenu : []
        },
        fallbackSubmenus() {
            return [
                {
                    id: "usuarios",
                    nombre: this.labels.users,
                    descripcion: this.labels.usersd,
                    ruta: "/users",
                },
                {
                    id: "menus",
                    nombre: this.labels.menu,
                    descripcion: this.labels.descripMenu,
                    ruta: "/menus",
                },
                {
                    id: "submenus",
                    nombre: this.labels.subMenu,
                    descripcion: this.labels.descripSubMenu,
                    ruta: "/submenus",
                },
                {
                    id: "roles",
                    nombre: this.labels.roles,
                    descripcion: this.labels.descripRole,
                    ruta: "/roles",
                },
                {
                    id: "cargues",
                    nombre: this.labels.cargues,
                    descripcion: this.labels.carguesd,
                    ruta: "/cargueFormato",
                },
                {
                    id: "buttoncontrol",
                    nombre: this.labels.buttonControl,
                    descripcion: this.labels.buttonControld,
                    ruta: "/buttonControlAdm",
                },
            ]
        }
    },
    methods: {
        goToRoute(subMenu) {
            const targetRoute = this.resolveRoute(subMenu)
            if (!targetRoute) return

            const routeExists = this.$router.getRoutes().some(route => route.path === targetRoute)
            if (!routeExists) {
                console.error(`La ruta ${targetRoute} no existe en el router`)
                this.$toast?.error(`La ruta ${targetRoute} no está disponible`)
                return
            }
            this.$router.push(targetRoute)
        },
        resolveRoute(subMenu) {
            const rawPath = String(subMenu?.ruta || "").trim()
            const rawName = String(subMenu?.nombre || "").trim().toLowerCase()
            const normalizedPath = rawPath
                ? (rawPath.startsWith("/") ? rawPath : `/${rawPath}`)
                : ""

            const routeMapByName = {
                usuarios: "/users",
                user: "/users",
                users: "/users",
                menús: "/menus",
                menus: "/menus",
                submenús: "/submenus",
                submenus: "/submenus",
                roles: "/roles",
                cargues: "/cargueFormato",
                cargue: "/cargueFormato",
                "panel de control": "/buttonControlAdm",
                "control panel": "/buttonControlAdm",
                buttoncontrol: "/buttonControlAdm",
            }

            const existingRoute = this.$router.getRoutes().find(route => route.path === normalizedPath)
            if (existingRoute) {
                return normalizedPath
            }

            return routeMapByName[rawName] || normalizedPath || null
        },
        async loadSubmenus() {
            this.isLoading = true
            this.error = false
            
            try {
                const menusResponse = await Menu.getAllMenu()
                const menus = menusResponse?.data?.listMenu || []
                const adminMenu = menus.find((menu) => {
                    const route = String(menu?.ruta || "").toLowerCase()
                    const name = String(menu?.nombre || "").toLowerCase()
                    return route === "administrador" || route === "/administrador" || name === "administrador"
                })
                const menuId = adminMenu?.id || 2
                const res = await SubMenu.subMenuByMenuByRol(menuId, this.$store.state.userRole)
                this.listaSubMenu = (res?.data?.submenus || []).map((item) => ({
                    ...item,
                    ruta: this.resolveRoute(item),
                }))
            } catch (err) {
                console.error('Error al cargar submenús:', err)
                this.error = true
                this.$toast?.error('Error al cargar las opciones')
            } finally {
                this.isLoading = false
            }
        }
    },
    mounted() {
        this.loadSubmenus()
    },
    beforeDestroy() {
        this.isLoading = false
        this.listaSubMenu = []
    }
}
</script>

<style src="../main.css"></style>